<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-stepper v-model="pageStep" class="elevation-1">
        <v-stepper-header class="elevation-1">
          <v-stepper-step :complete="pageStep > 1" step="1">Drawing</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="pageStep > 2" step="2">Setting</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Printing</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="dotted grey lighten-2 elevation-0" height="380px" ref="canvasWrap">
              <VueSignaturePad id="canvasPad" saveType="image/svg+xml" ref="signaturePad" />
            </v-card>
            <v-toolbar flat dark class="mt-3 primary">
              <v-toolbar-items>
                <v-btn flat @click="undo"><v-icon class="mr-1">undo</v-icon>Undo</v-btn>
                <v-btn flat @click="clear"><v-icon class="mr-1">clear</v-icon>Clear</v-btn>
              </v-toolbar-items>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn flat @click="save"><v-icon class="mr-1">skip_next</v-icon>Next</v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card class="elevation-0" height="380px">
              <VueFriendlyIframe v-if="pageStep === 2" :src="editorPath" @load="onIframeLoad" class="scroll-wrapper" ref="gcodeFrame"></VueFriendlyIframe>
            </v-card>
            <v-toolbar flat dark class="mt-3 primary">
              <v-toolbar-items>
                <v-btn flat @click="pageStep = 1; initCanvas"><v-icon class="mr-1">skip_previous</v-icon>Previous</v-btn>
              </v-toolbar-items>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn flat @click="printStart"><v-icon class="mr-1">print</v-icon>Print</v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-card class="elevation-0" height="380px">
              <v-flex pt-5 xs4 offset-xs4 class="text-xs-center">
                <v-icon v-if="completed === false && startOrder === true" color="grey" size="120px">print</v-icon>
                <v-icon v-if="completed === true" color="primary" size="120px">print</v-icon>
              </v-flex>
              <v-progress-linear v-if="completed === false && startOrder === true" color="secondary lighten-2" height="20" v-model="progressValue"></v-progress-linear>
              <v-flex v-if="completed === true" pt-5 xs4 offset-xs4 class="text-xs-center display-1 font-weight-bold primary--text">
                Print Completed!
              </v-flex>
            </v-card>
            <v-toolbar flat dark class="mt-3 primary">
              <v-toolbar-items>
                <v-btn :disabled="completed" flat @click="printCancel"><v-icon class="mr-1">cancel</v-icon>Cancel</v-btn>
              </v-toolbar-items>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn :disabled="completed === false" flat @click="goFirst"><v-icon class="mr-1">refresh</v-icon>Go First</v-btn>
              </v-toolbar-items>
            </v-toolbar>          
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>    
      <v-snackbar bottom v-model="snack" :timeout="snackTimeout" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Close</v-btn>
      </v-snackbar>
      <!--<Loading :show="spinnerShow" :label="spinnerLabel"></Loading>-->
    </v-flex>
  </v-layout>
</template>
<script>
  import VueFriendlyIframe from 'vue-friendly-iframe'
  //import Loading from 'vue-full-loading'
  //import base64Img from 'base64-img'
  //import img2gcode from 'img2gcode'
  import FileSaver from 'file-saver'
  export default {
    name: 'Canvas',
    components: {
      VueFriendlyIframe
      //Loading,
      //base64Img,
      //img2gcode
    },
    data () {
      return {
        snack: false,
        snackColor: '',
        snackText: '',
        snackTimeout: 2000,
        loading: true,
        spinnerShow:false,
        spinnerLabel: 'Loading...',
        loadingInterval: {},
        progressValue: 0,
        completed: false,
        startOrder: false,
        imageData: '',
        blobImg:'',
        gCode:'',
        pageStep: '1',
        laserMin: 22,
        laserMax: 65,
        laserOff: 13,
        whiteLevel: 0,
        travelRate: 3000,
        scanRate: 800,
        overDist: 3,
        srcHeight: 400,
        hRes: 1,
        scanGap: 0,
        startX: 0,
        startY: 0,
        baseUrl: 'vendor/jscut/jscut.html',
        editorParam: this.blobImg,
        editorPath: '',
        iframeLoading: false,
      }
    },
    created () {
      this.$root.breadcrumbs = [
        {
          text: 'Home',
          disabled: false,
          href: '/'
        },
        {
          text: 'Canvas',
          disabled: true
        }
      ]
    },
    watch: {
    },
    computed: {
    /*
      initWidth () {
        return this.$refs.canvasWrap.$el.clientWidth
      },
      initHeight () {
        return this.$refs.signaturePad.$el.clientHeight
      }*/
    },
    mounted () {
      this.initCanvas()
    },
    beforeDestroy () {
      clearInterval(this.loadingInterval)
    },
    methods: {
      initCanvas () {
        this.$nextTick(() => {
        let initWidth = this.$refs.signaturePad.$el.clientWidth
        let initHeight = this.$refs.signaturePad.$el.clientHeight
        this.$refs.signaturePad.$el.firstChild.setAttribute('width', initWidth + 'px')
        this.$refs.signaturePad.$el.firstChild.setAttribute('height', initHeight + 'px')
        //document.getElementsByTagName('canvas')[0].setAttribute('height', window.innerHeight + 'px')
        console.log(initWidth)
        console.log(initHeight)
        })
      },
      undo() {
        this.$refs.signaturePad.undoSignature()
      },
      save() {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
        console.log(isEmpty)
        console.log(data)
        this.imageData = data

        //this.parsingGcode(data)
       // this.decodeBase64Image(data)
        this.setEditor()
        //this.snackSave()
        this.pageStep = 2
      },
      clear() {
        this.$refs.signaturePad.clearSignature()
      },
      decodeBase64Image(base64Img) {
        let matches = base64Img.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/),
        response = {}
        if (matches.length !== 3) {
          return new Error('Invalid input string');
        }
        response.type = matches[1];
        response.data = new Buffer(matches[2], 'base64');
        this.blobImg = response
        //return response;
        console.log(response)
      },
      parsingGcode (imageData) {
        this.axios.post(`gcode.php`, {
          LaserMin: this.laserMin,
          LaserMax: this.laserMax,
          LaserOff: this.laserOff,
          whiteLevel: this.whiteLevel,
          feedRate: this.scanRate,
          travelRate: this.travelRate,
          overScan: this.overDist,
          offsetY: this.startY,
          sizeY: this.srcHeight,
          scanGap: this.scanGap,
          offsetX: this.startX,
          resX: this.hRes,
          //imageData: this.blobImg  //use binary images
          //imageData: this.imageData
          imageData:imageData
        },
        {
          headers: {
            'Access-Control-Allow-Origin': 'http://localhost:8080',
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,HEAD,OPTIONS',
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Credentials': true,
            //'Content-Type': 'application/x-www-form-urlencoded'
            'Content-Type': 'application/json'
            },
          credentials: 'include',
          withCredentials: true
          })
          .then((result) => {
            this.gCode = result.data
            /*
            let blob = new Blob([result.data], {type: "text/plain;charset=utf-8"});
            FileSaver.saveAs(blob, "test.gcode");*/

            this.snackSave()
            //this.pageStep = 2
            //console.log('result::' + result)
          })
          .catch(e => { 
            this.snackError(e)
            //this.errors.push(e)
            console.log(e)
          })
      },
      setEditor () {
        this.editorParam = JSON.stringify(this.imageData)
        sessionStorage.setItem('tempImage', this.imageData)
        this.editorPath = this.baseUrl //+ '?data=' + this.editorParam
        console.log(this.editorPath)
      },
      onIframeLoad() {
        /*
        let iframeEl = this.$refs.gcodeFrame.$el.children[0]
        this.editorParam = JSON.stringify(this.blobImg)
        this.editorPath = this.baseUrl + '?data=' + this.editorParam*/
        console.log('loaded!')
       // iframeEl.setAttribute('id','gFrame')
       // iframeEl.setAttribute('name','gFrame')
       // iframeEl.contentWindow.postMessage({call:'sendValue', value:this.blobImg}, '*')
        //window.gcodeEditor.imgDataForm.imgData.value = this.blobImg
        //console.log(this.editorPath)
       /* iframe.data({
          svgImg: this.blobImg,
          fileName: "tempImage.svg"
        })*/
        this.iframeLoading = true
      },
      printStart () {
        this.snackPrint()
        this.pageStep = 3
        this.startOrder = true
        this.printProgress()
      },
      printProgress () {
        this.loadingInterval = setInterval(() => {
          if(this.progressValue === 100) {
            this.completed = true
            this.snackComplete()
          }
          this.progressValue += 10
        }, 1000)
      },
      initProcess() {
        clearInterval(this.loadingInterval)
        this.startOrder = false
        this.completed = false
        this.progressValue = 0
      },
      goFirst () {
        this.clear()
        this.initProcess()
        this.pageStep = 1
      },
      printCancel () {
        this.initProcess() 
        this.pageStep = 2
      },
      snackSave () {
        this.snack = true
        this.snackColor = 'success'
        this.snackTimeout = 2000
        this.snackText = 'Yay! Saved. Move to Next Step!'
      },
      snackPrint () {
        this.snack = true
        this.snackColor = 'success'
        this.snackTimeout = 2000
        this.snackText = 'Start Print Progress'
      },
      snackError (e) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = '' + e
      },
      snackComplete () {
        this.snack = true
        this.snackColor = 'primary'
        this.snackText = 'Print Completed'
      }
    }
  }
</script>
<style>
.dotted {
  background: linear-gradient(90deg, #fff 20px, transparent 1%) center, linear-gradient(#fff 20px, transparent 1%) center, #fff;
  background-size: 22px 22px;
}
.centered-input input{
  text-align: center;
  font-size: 14px
}

.v-input--slider label {
  font-size: 14px;
}
iframe {
  width: 100%;
  height: 101%;
  border: none
}
.scroll-wrapper {
  right: 0; 
  bottom: 0; 
  left: 0;
  top: 0;
  -webkit-overflow-scrolling: touch;
  overflow:auto;
  height: 100%
}
</style>
